import React from "react";
import { linkifyText } from "../lib/linkifyText";

/**
 * Renders plain text with auto-linked URLs and phone numbers.
 */
export default function LinkifiedText({
  children,
  className = "",
  linkClassName = "underline underline-offset-2 hover:opacity-80",
}) {
  const text = typeof children === "string" ? children : String(children || "");
  const segments = linkifyText(text);

  if (!segments.length) return null;

  return (
    <span className={className}>
      {segments.map((segment, index) => {
        if (segment.type === "text") {
          return <React.Fragment key={`text-${index}`}>{segment.text}</React.Fragment>;
        }

        return (
          <a
            key={`link-${index}`}
            href={segment.href}
            className={linkClassName}
            {...(segment.external ? { target: "_blank", rel: "noreferrer noopener" } : {})}
          >
            {segment.text}
          </a>
        );
      })}
    </span>
  );
}
